import { render } from "./cardRealEstate.vue?vue&type=template&id=1d948cac&scoped=true"
import script from "./cardRealEstate.vue?vue&type=script&lang=js"
export * from "./cardRealEstate.vue?vue&type=script&lang=js"

import "./cardRealEstate.vue?vue&type=style&index=0&id=1d948cac&scoped=true&lang=css"
import "./cardRealEstate.vue?vue&type=style&index=1&id=1d948cac&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1d948cac"]])

export default __exports__